import { Preset } from "@redotech/redo-fulfillment-parcel-common/presets";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

function presetToItem(preset: Preset): RedoListItem<Preset> {
  return {
    id: preset._id,
    type: "text",
    hotkey: preset.hotkey,
    value: preset,
    text: preset.name,
  };
}

export const PresetSelection = memo(function PresetSelection({
  presets,
  onPresetSelect,
  selectedPreset,
  disabled,
}: {
  presets: readonly Preset[];
  onPresetSelect: (preset: Preset) => void;
  selectedPreset: Preset | undefined;
  disabled: boolean;
}) {
  if (presets.length === 0) {
    return null;
  }

  return (
    <Flex flexDirection="column" gap="xs" w="full">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Shipment preset
      </Text>
      <RedoSingleSelectDropdownInput<Preset>
        disabled={disabled}
        options={presets.map(presetToItem)}
        optionSelected={({ item }) => onPresetSelect(item.value)}
        placeholder="Select a preset"
        selectedItem={selectedPreset ? presetToItem(selectedPreset) : undefined}
        size="xs"
      />
    </Flex>
  );
});
